import styled from '@emotion/styled';
import { IconButton } from 'ui-components/common/IconButton';
import { ProfileImage } from 'app-components/accounts/profiles/ProfileImage';
import { useAuthState } from 'contexts/AuthProvider';
import { useMenuRef } from 'ui-hooks/useMenuRef';
import { DirittoStudioMenu } from 'ui-components/navigations/dirittoStudioMenu/DirittoStudioMenu';

export const DirittoStudioMenuToggleButton = () => {
  const { ref, isOpen, setOpen } = useMenuRef<HTMLDivElement>();
  const { profile } = useAuthState();

  if (!profile) {
    return null;
  }

  return (
    <StyledContainer ref={ref}>
      <StyledImageWrapper onClick={() => setOpen(prev => !prev)}>
        <ProfileImage file={profile.profileImage} defaultImageKey={profile.nickname} size={32} />
      </StyledImageWrapper>
      {isOpen && (
        <StyledMenuWrapper>
          <DirittoStudioMenu onBlur={() => setOpen(false)} />
        </StyledMenuWrapper>
      )}
    </StyledContainer>
  );
};

const StyledContainer = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
`;

const StyledImageWrapper = styled(IconButton)`
  position: relative;
  width: 32px;
  height: 32px;

  & img {
    width: 100%;
    border-radius: 50%;
  }
`;

const StyledMenuWrapper = styled.div`
  position: relative;
`;
